import styled, { css } from 'styled-components';
import { IProps } from './interfaces';


export const GooglePlayImage = styled.img`
    height: 76px;
`;

export const AppStoreImage = styled.img`
    margin: 12.5px 12px 11px;
    height: 51px;
`;

const mobileSpacing = css`
    flex-direction: column;
    align-items: center;
    a {
        margin-top: -8px;
        margin-bottom: -8px;
    }
`

export const Container = styled.div<IProps>`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    ${p => p.theme.xs(mobileSpacing)}
    ${p => p.asMobile && mobileSpacing}
`;
